'use client';

import { CardContent } from '@/components/ui/card';
import { CampaignGoalLoadingState } from '@/components/glitch-ui/campaign-goal-loading-state';

export function GenerateSpinner({ text }: { text: string }) {
  return (
    <CardContent className='p-6 mx-6 rounded-md'>
      <CampaignGoalLoadingState message={text} />
    </CardContent>
  );
}
